import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createCommentVNode as _createCommentVNode } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_el_option = _resolveComponent("el-option");
  var _component_el_select = _resolveComponent("el-select");
  var _component_el_input = _resolveComponent("el-input");
  return _openBlock(), _createElementBlock("div", null, [_ctx.appVars.verified_senders.length ? (_openBlock(), _createBlock(_component_el_select, {
    key: 0,
    placeholder: $props.field.placeholder,
    filterable: "",
    "allow-create": "",
    modelValue: $data.model,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
      return $data.model = $event;
    })
  }, {
    "default": _withCtx(function () {
      return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.appVars.verified_senders, function (email) {
        return _openBlock(), _createBlock(_component_el_option, {
          key: email,
          value: email
        }, null, 8 /* PROPS */, ["value"]);
      }), 128 /* KEYED_FRAGMENT */))];
    }),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["placeholder", "modelValue"])) : (_openBlock(), _createBlock(_component_el_input, {
    key: 1,
    type: $props.field.data_type,
    placeholder: $props.field.placeholder,
    modelValue: $data.model,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) {
      return $data.model = $event;
    })
  }, null, 8 /* PROPS */, ["type", "placeholder", "modelValue"]))]);
}